import { Navigate } from 'react-router-dom'
import { isStaffAuthenticated } from '@/lib/backoffice-auth'

export function BackofficeProtectedRoute({ children }: { readonly children: React.ReactNode }) {
  if (!isStaffAuthenticated()) {
    return <Navigate to="/backoffice/login" replace />
  }
  return <>{children}</>
}
